export default __webpack_public_path__ + "locales/sr-Latn-RS/UploadPanel.json?hash=244c3cef6ce1654c773aa08d0e7548e0";